export function formatEuro(amount: number): string {
  return amount.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
}

export function formatDate(dateStr: string): string {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

export function getTodayIso(): string {
  return new Date().toISOString().slice(0, 10);
}

export const DEFAULT_TAKEN_BY_OPTIONS = ["Emeni", "Zenchef", "François", "Philippe", "Shelihane", "Matthieu", "Lucas", "Régis"];
export const DEFAULT_CASHED_BY_OPTIONS = ["Emeni", "Zenchef", "François", "Philippe", "Shelihane", "Matthieu", "Lucas", "Régis"];

export type Board = {
  id: number;
  title: string;
  createdAt: string;
  isArchived: boolean;
  takenByOptions: string[];
  cashedByOptions: string[];
};

export type Reservation = {
  id: number;
  lastName: string;
  firstName: string;
  phone: string;
  email: string;
  alertSentAt: string | null;
  time: string;
  createdDate: string;
  paidDate: string;
  adults: number;
  children: number;
  tarifAdult: number;
  tarifChild: number;
  cb: number;
  amex: number;
  cash: number;
  cheque: number;
  zen: number;
  virm: number;
  comment: string;
  tableNumber: string;
  takenBy: string;
  cashedBy: string;
  boardId?: number;
  boardTitle?: string;
};

export function mapBoardFromApi(b: any): Board {
  let taken: string[] = DEFAULT_TAKEN_BY_OPTIONS;
  let cashed: string[] = DEFAULT_CASHED_BY_OPTIONS;
  try {
    const parsed = typeof b.taken_by_options === 'string' ? JSON.parse(b.taken_by_options) : b.taken_by_options;
    if (Array.isArray(parsed) && parsed.length > 0) taken = parsed;
  } catch {}
  try {
    const parsed = typeof b.cashed_by_options === 'string' ? JSON.parse(b.cashed_by_options) : b.cashed_by_options;
    if (Array.isArray(parsed) && parsed.length > 0) cashed = parsed;
  } catch {}
  return {
    id: b.id,
    title: b.title,
    createdAt: formatDate(b.created_at),
    isArchived: !!b.is_archived,
    takenByOptions: taken,
    cashedByOptions: cashed,
  };
}

export function mapReservationFromApi(r: any, boardTitle?: string): Reservation {
  return {
    id: r.id,
    lastName: r.last_name,
    firstName: r.first_name,
    phone: r.phone,
    email: r.email || '',
    alertSentAt: r.alert_sent_at || null,
    time: r.time,
    createdDate: r.created_date,
    paidDate: r.paid_date,
    adults: r.adults,
    children: r.children,
    tarifAdult: r.tarif_adult,
    tarifChild: r.tarif_child,
    cb: r.cb,
    amex: r.amex,
    cash: r.cash,
    cheque: r.cheque,
    zen: r.zen,
    virm: r.virm,
    comment: r.comment,
    tableNumber: r.table_number || "",
    takenBy: r.taken_by,
    cashedBy: r.cashed_by,
    boardId: r.board_id,
    boardTitle,
  };
}

export function reservationToApiPayload(r: Reservation) {
  return {
    lastName: r.lastName,
    firstName: r.firstName,
    phone: r.phone,
    email: r.email,
    time: r.time,
    createdDate: r.createdDate,
    paidDate: r.paidDate,
    adults: r.adults,
    children: r.children,
    tarifAdult: r.tarifAdult,
    tarifChild: r.tarifChild,
    cb: r.cb,
    amex: r.amex,
    cash: r.cash,
    cheque: r.cheque,
    zen: r.zen,
    virm: r.virm,
    comment: r.comment,
    tableNumber: r.tableNumber,
    takenBy: r.takenBy,
    cashedBy: r.cashedBy,
  };
}

// Champs numériques pouvant être vides à l'écran (affiche "" plutôt que 0)
export const emptyableNumber = (v: number) => (v === 0 ? "" : v);
